import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import classnames from 'classnames2';
import { capitalize } from 'lodash';
import React from 'react';
import { Icon } from '../../Icon';
import { InputSizes, ValidationStates } from '../enums';
import styles from '../BaseInput/BaseInput.scss';
export var ParsedNumberInput = /*#__PURE__*/function (_React$Component) {
  _inherits(ParsedNumberInput, _React$Component);

  var _super = _createSuper(ParsedNumberInput);

  function ParsedNumberInput(props) {
    var _classnames;

    var _this;

    _classCallCheck(this, ParsedNumberInput);

    _this = _super.call(this, props);

    _this.createChangeHandler = function (callback) {
      return callback && function (e) {
        var parsed = parseFloat(e.target.value.replace(/[$¢€,]+/g, ''));

        _this.setState({
          rawInput: e.target.value,
          numericInput: parsed,
          invalid: _this.props.validationState && _this.props.validationState === ValidationStates.Error || isNaN(parsed)
        });

        callback(parsed);
      };
    };

    var inputSize = capitalize(props.size) || InputSizes.Default;
    var containerStyle = classnames(styles.container, (_classnames = {}, _defineProperty(_classnames, styles.defaultSize, inputSize === InputSizes.Default), _defineProperty(_classnames, styles.smallSize, inputSize === InputSizes.Small), _defineProperty(_classnames, styles.largeSize, inputSize === InputSizes.Large), _defineProperty(_classnames, styles.successState, props.validationState === ValidationStates.Success), _defineProperty(_classnames, styles.errorState, props.validationState === ValidationStates.Error), _defineProperty(_classnames, styles.disabledState, props.disabled), _classnames));
    _this.state = {
      invalid: props.validationState && props.validationState === ValidationStates.Error,
      rawInput: props.value || '',
      numericInput: null,
      containerStyle: containerStyle
    };
    return _this;
  }

  _createClass(ParsedNumberInput, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          containerStyle = _this$state.containerStyle,
          invalid = _this$state.invalid;
      var inputProps = {};

      if (this.props.value !== undefined && this.props.value !== null && this.props.value !== '') {
        inputProps = Object.assign(inputProps, {
          value: this.props.value
        });
      }

      if (this.props.defaultValue) {
        inputProps = Object.assign(inputProps, {
          defaultValue: this.props.defaultValue
        });
      }

      return React.createElement("div", {
        className: classnames(containerStyle, this.props.className)
      }, React.createElement("input", Object.assign({
        className: classnames(styles.input, this.props.inputClassName),
        "data-test": this.props.dataTest,
        disabled: this.props.disabled,
        id: this.props.id,
        maxLength: this.props.maxLength,
        minLength: this.props.minLength,
        onBlur: this.createChangeHandler(this.props.onBlur),
        onChange: this.createChangeHandler(this.props.onChange),
        onFocus: this.props.onFocus,
        onKeyDown: this.props.onKeyDown,
        onKeyUp: this.props.onKeyUp,
        placeholder: this.props.placeholder,
        required: this.props.required,
        type: "text",
        min: this.props.min,
        max: this.props.max
      }, inputProps)), React.createElement("span", {
        className: styles.iconWrapper
      }, this.props.validationState === ValidationStates.Success && React.createElement(Icon, {
        className: styles.icon,
        icon: "status-success"
      }), invalid && React.createElement(Icon, {
        className: styles.icon,
        icon: "status-error"
      })));
    }
  }]);

  return ParsedNumberInput;
}(React.Component);
ParsedNumberInput.displayName = 'Input.ParsedNumberInput';